import { useParams } from 'react-router-dom';
import { useGoToPath } from 'catering/hooks/navigation/useGoToPath';
import { buildCartPath } from 'catering/helpers/paths';

export function useGoToCart() {
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  return (isRedirect = false) =>
    go({ path: buildCartPath(locationSlug), isRedirect });
}
